import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";

import { Tabs, Tab } from "material-ui/Tabs";

import theme from "theme";

class PageMenu extends Component {
  state = {
    tab: "a"
  };

  handleChange = (key) => {
    this.setState({ ...this.state, tab: key });
    if (this.props.onNav) {
      this.props.onNav(key);
    }
  };

  renderTabs = () => {
    return _.map(this.props.tabs, tab => {
      return (
        <li key={tab.key}>
          <a onClick={() => this.handleChange(tab.key)}>{tab.label}</a>
        </li>
      );
    });
  };

  render() {
    return <ul className="page__menu">{this.renderTabs()}</ul>;
  }
}

export default PageMenu;



// WEBPACK FOOTER //
// ./src/components/Page/PageMenu.jsx